import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.name";
import * as React from 'react';
import { user } from 'rxfire/auth';
import { preloadAuth, preloadObservable, useAuth, useObservable } from '..';
import { from } from 'rxjs';
import { useFirebaseApp } from '../firebaseApp';
export function preloadUser(options) {
  var _a;

  var firebaseApp = ((_a = options) === null || _a === void 0 ? void 0 : _a.firebaseApp) || useFirebaseApp();
  return preloadAuth({
    firebaseApp: firebaseApp
  }).then(function (auth) {
    var result = preloadObservable(user(auth()), "auth:user:" + firebaseApp.name);
    return result.toPromise();
  });
}
export function useUser(auth, options) {
  var _a;

  auth = auth || useAuth();
  var currentUser = auth.currentUser || ((_a = options) === null || _a === void 0 ? void 0 : _a.startWithValue);
  return useObservable(user(auth), "auth:user:" + auth.app.name, currentUser);
}
export function useIdTokenResult(user, forceRefresh) {
  if (forceRefresh === void 0) {
    forceRefresh = false;
  }

  if (!user) {
    throw new Error('you must provide a user');
  }

  var idToken$ = from(user.getIdTokenResult(forceRefresh));
  return useObservable(idToken$, "auth:idTokenResult:" + user.uid + ":forceRefresh=" + forceRefresh);
}
export function ClaimsCheck(_a) {
  var user = _a.user,
      fallback = _a.fallback,
      children = _a.children,
      requiredClaims = _a.requiredClaims;
  var claims = useIdTokenResult(user, false).claims;
  var missingClaims = {};
  Object.keys(requiredClaims).forEach(function (claim) {
    if (requiredClaims[claim] !== claims[claim]) {
      missingClaims[claim] = {
        expected: requiredClaims[claim],
        actual: claims[claim]
      };
    }
  });

  if (Object.keys(missingClaims).length === 0) {
    return React.createElement(React.Fragment, null, children);
  } else {
    return React.createElement(React.Fragment, null, fallback);
  }
}
export function AuthCheck(_a) {
  var auth = _a.auth,
      fallback = _a.fallback,
      children = _a.children,
      requiredClaims = _a.requiredClaims;
  var user = useUser(auth);

  if (user) {
    return requiredClaims ? React.createElement(ClaimsCheck, {
      user: user,
      fallback: fallback,
      requiredClaims: requiredClaims
    }, children) : React.createElement(React.Fragment, null, children);
  } else {
    return React.createElement(React.Fragment, null, fallback);
  }
}